var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-button-wrapper"},[_c('v-btn',{ref:"waitlistBtn",staticClass:"text-capitalize signup-button",attrs:{"dark":"","text":"","color":"#0366f9","large":""},on:{"click":_vm.openSignUpForm}},[_c('span',{staticClass:"white--text"},[_vm._v("Sign Up for Free")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }